export const CONFERENCE_INFO = {
  alwaysVisible: ['logo'],
  autoHide: [
    'highlight-moment',
    'subject',
    'conference-timer',
    'participants-count',
    'e2ee',
    'transcribing',
    'video-quality',
    'insecure-room',
    'top-panel-toggle',
    'recording',
    'raised-hands-count'
  ]
};
